import React, { Component } from 'react';
import { View, Text } from 'react-native';
import { SDate, SHr, SIcon, SImage, SList, SNavigation, SPage, SPopup, SText, SView } from 'servisofts-component';
import ActionMusculo from './ActionMusculo';
import Container from '../../../../Components/Container';
import SSocket from 'servisofts-socket';
import Crear from './crear';
import { FlatList } from 'react-native-gesture-handler';
export default class root extends Component {

    static INSTANCE = null;
    state = {
        data: null
    }
    componentDidMount() {
        root.INSTANCE = this;
        ActionMusculo.getAll().then((resp) => {
            resp.sort((a, b) => {
                if (a.descripcion > b.descripcion) return 1;
                if (a.descripcion < b.descripcion) return -1;
                return 0;
            })
            this.setState({ data: resp })
        })
    }
    handleCrear() {
        // SNavigation.navigate("/marketing/tutoriales/musculo/crear");
        // SPopup.open({
        //     key:"popup_crear_musculo",
        //     content:<SView width={500} height={500} center backgroundColor='#f0f'> 
        //     </SView>
        // })
        Crear.open({});
    }
    render() {
        return <SPage title="Tutoriales Musculos" >
            <Container>
                <SHr />
                <SView col={"xs-12"} row>
                    <SView height={40} width={40} center card onPress={this.handleCrear.bind(this)}>
                        <SIcon name='Add' />
                    </SView>
                    {/* <SText card padding={8} onPress={this.handleCrear.bind(this)}>{"Nuevo musculo"}</SText> */}
                </SView>
                <SHr />
                <FlatList
                    style={{ width: "100%" }}
                    ItemSeparatorComponent={() => <SHr />}
                    data={Object.values(this.state.data ?? {}).sort((a, b) => {
                        return a.index - b.index;
                    })}
                    renderItem={({ item }) => {
                        const obj = item;
                        return <SView col={"xs-12"} padding={8} card row onPress={() => {
                            SNavigation.navigate("/marketing/tutoriales/musculo", { key: obj.key })
                        }}>
                            <SView height={40} width={40} center card>
                                <SImage src={SSocket.api.root + "tutorial_musculo/" + obj.key + "?time=" + new SDate().getTime()} />
                            </SView>
                            <SView flex height style={{
                                justifyContent: "center",
                                alignItems: "flex-start",
                                paddingLeft: 8
                            }} >
                                <SText bold fontSize={18}>{obj.descripcion}</SText>


                            </SView>
                            <SView height={40} width={40} center card onPress={() => {
                                Crear.open({ data: obj })
                            }}>
                                <SIcon name='Edit' />
                            </SView>
                            <SView width={8} />
                            <SView height={40} width={40} center card onPress={() => {
                                SPopup.confirm({
                                    title: "Eliminar Musculo",
                                    message: "¿Estas seguro de eliminar el musculo?",
                                    onPress: () => {
                                        ActionMusculo.eliminar(obj.key).then((resp) => {
                                            this.componentDidMount();
                                        })
                                    }
                                })
                            }}>
                                <SIcon name='Delete' />
                            </SView>
                        </SView>
                    }}
                />
            </Container>
            {/* <SText>{JSON.stringify(this.state.data)}</SText> */}
        </SPage>
    }
}
